import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DevicesState {
    devices: string[];
}

const initialState: DevicesState = {
    devices: []
}

const selectedDeviceSlice = createSlice({
   name: 'selectedDevices',
   initialState,
   reducers: {
    setSelectedDevices: (state, action: PayloadAction<string[]>) => {
        state.devices = action.payload;
    },
    
   } 
});

export const { setSelectedDevices } = selectedDeviceSlice.actions;

export default selectedDeviceSlice.reducer;
